import { ofType } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { types as actions, setLocationsAction } from '../../reducers/actions';
import { LocationService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_LOCATIONS),
    switchMap(action =>
      forkJoin(
        of(action.zoneId),
        LocationService.getByZoneId(action.zoneId, store)
      ).pipe(
        map(([zoneId, data]) => setLocationsAction(zoneId, data)),
        catchError(retryAuthentication(action$, 'epics/locations/getLocations'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/locations/getLocations.js